// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__3dXfA","inputSuccess":"FieldCurrencyInput_inputSuccess__32sJQ","inputError":"FieldCurrencyInput_inputError__N8JW9"};